/* ----------------------------------------------------------------------------------------------
   CARRELLO A SCOMPARSA: cambio taglia sul posto, quantita' istantanea e foto a tutto schermo
   Markup: snippets/carrello-riga.liquid (dentro sections/cart-drawer.liquid). CSS: assets/carrello.css.
   Frecce, puntini e swipe della galleria li gestisce il modulo "galleria" di assets/scheda-pallini-fratelli.js
   (host = elemento con data-galleria-host). Caricato da layout/theme.liquid con defer. File nostro.

   CAMBIO TAGLIA
   "Modifica" apre l'elenco delle taglie; al click su una taglia disponibile:
     1. cart/add.js con la nuova variante, stessa quantita' e stesse proprieta' della riga;
     2. cart/change.js con quantita' 0 sulla riga vecchia, chiedendo anche le sezioni da rirenderizzare
        (le stesse che Prestige raccoglie con l'evento cart:prepare-bundled-sections);
     3. evento cart:change come lo emette Prestige: il drawer si rirenderizza da solo, la barra spedizione
        gratuita e gli altri ascoltatori si aggiornano.
   Se l'aggiunta fallisce del tutto (es. taglia esaurita nel frattempo) niente viene tolto e l'errore di
   Shopify compare sotto le taglie. ATTENZIONE, misurato il 15/09/2026: con quantita' superiore alla scorta
   Shopify risponde 422 ("Solo 1 articolo e' stato aggiunto...") ma AGGIUNGE COMUNQUE quello che puo'.
   Percio' dopo un 422 si rilegge cart.js: se la nuova taglia e' aumentata, il cambio viene completato
   (riga vecchia tolta) e il messaggio di Shopify compare sotto la riga nuova dopo il rirendering.
   Se la nuova taglia era gia' nel carrello, Shopify somma le quantita'.

   QUANTITA' ISTANTANEA (18/09/2026)
   In Prestige il + e il - della riga sono link cart/change: ogni click e' una richiesta, il numero cambia solo
   quando il drawer si rirenderizza (misurato: 0,7 s dal click, quasi tutto tempo del server di Shopify) e due
   click veloci mandano due volte la stessa quantita', perche' i link sono calcolati al rendering. Qui il click
   viene intercettato in fase di cattura (prima del delegate di Prestige): il numero nel riquadro cambia subito,
   il riquadro passa in attesa (classe is-attesa, numero grigio) e dopo 300 ms di calma parte UNA richiesta con
   la quantita' finale, lanciando sull'input lo stesso evento "change" che Prestige ascolta quando il numero si
   scrive a mano: rirendering, eventi e barra di caricamento restano i suoi. Il - a quantita' 1 toglie la riga
   subito, come il link, e finche' la riga non sparisce gli altri click su di essa sono ignorati.
   Lo stato sta per CHIAVE di riga, non per elemento: a ogni risposta Prestige rimpiazza tutto il contenuto del
   drawer, quindi l'input in cui abbiamo scritto il numero viene buttato via. Una richiesta in volo per riga:
   i click arrivati nel frattempo aggiornano l'obiettivo e la richiesta successiva parte al rirendering. Se la
   richiesta fallisce (Prestige non rirenderizza e non gestisce l'errore) o non risponde entro 8 s, il numero
   torna quello reso.

   FOTO A TUTTO SCHERMO
   Al click sulla foto si apre un <dialog> con showModal(). Il suo contenuto (titolo, X, foto grandi, frecce e
   puntini dello snippet scheda-galleria) sta nel <template> della riga: qui si clona e basta.
   Il dialog sta nel TOP LAYER, quindi esce dal drawer
   (che e' animato con transform e imprigionerebbe un position:fixed) e non lo chiude. Il dialog viene
   creato al momento dentro <cart-drawer>: i click al suo interno risultano "dentro" al drawer, cosi' la
   focus-trap di Prestige non lo chiude; alla chiusura viene rimosso (e comunque il drawer rimpiazza
   tutti i suoi figli a ogni aggiornamento del carrello).
   ESC: la focus-trap di Prestige ascolta keydown sul document in fase di cattura e chiuderebbe il
   drawer. Il nostro ascoltatore sta su window, sempre in cattura: viene prima, chiude solo il dialog e
   ferma l'evento. Frecce sinistra/destra scorrono le foto.
   ---------------------------------------------------------------------------------------------- */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function rigaDi(el) { return el.closest('.carrello-riga'); }

  function caricamento(inizio) {
    document.documentElement.dispatchEvent(new CustomEvent(inizio ? 'theme:loading:start' : 'theme:loading:end', { bubbles: true }));
  }

  function mostraErrore(riga, testo) {
    var p = riga.querySelector('.carrello-riga__errore');
    if (!p) return;
    p.textContent = testo || 'Errore';
    p.hidden = false;
  }

  function quantitaVariante(carrello, idVariante) {
    var tot = 0;
    ((carrello && carrello.items) || []).forEach(function (i) { if (i.variant_id === idVariante) tot += i.quantity; });
    return tot;
  }

  function leggiCarrello() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* dopo che Prestige ha rirenderizzato il drawer (evento cart-drawer:refreshed), mostra un messaggio
     sotto la riga della variante indicata; con un tempo massimo di attesa per non restare appesi */
  function mostraDopoRirendering(idVariante, testo) {
    var fatto = false;
    function prova() {
      if (fatto) return;
      var riga = document.querySelector('.carrello-riga[data-variant-id="' + idVariante + '"]');
      if (!riga) return;
      fatto = true;
      mostraErrore(riga, testo);
    }
    document.addEventListener('cart-drawer:refreshed', function h() { document.removeEventListener('cart-drawer:refreshed', h); setTimeout(prova, 50); });
    setTimeout(prova, 2500);
  }

  async function cambiaTaglia(opzione) {
    var riga = rigaDi(opzione);
    if (!riga || riga.getAttribute('aria-busy') === 'true') return;
    var chiaveVecchia = riga.getAttribute('data-line-key');
    var quantita = parseInt(riga.getAttribute('data-quantity'), 10) || 1;
    var nuovaVariante = parseInt(opzione.getAttribute('data-variant-id'), 10);
    var proprieta = null;
    try { proprieta = riga.hasAttribute('data-properties') ? JSON.parse(riga.getAttribute('data-properties')) : null; } catch (_) { proprieta = null; }
    if (!chiaveVecchia || !nuovaVariante) return;

    riga.setAttribute('aria-busy', 'true');
    var errore = riga.querySelector('.carrello-riga__errore');
    if (errore) errore.hidden = true;
    caricamento(true);

    var sezioni = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sezioni } }));

    try {
      var quantitaPrima = quantitaVariante(await leggiCarrello(), nuovaVariante);
      var nuovo = { id: nuovaVariante, quantity: quantita };
      if (proprieta && Object.keys(proprieta).length) nuovo.properties = proprieta;
      var aggiunta = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [nuovo] })
      });
      var messaggioDopo = '';
      if (!aggiunta.ok) {
        var dettaglio = {};
        try { dettaglio = await aggiunta.json(); } catch (_) {}
        var testo = dettaglio.description || dettaglio.message || 'Errore';
        var quantitaDopo = quantitaVariante(await leggiCarrello(), nuovaVariante);
        if (quantitaDopo <= quantitaPrima) {
          mostraErrore(riga, testo);
          return;
        }
        messaggioDopo = testo;
      }
      var carrello = await (await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: chiaveVecchia, quantity: 0, sections: sezioni.join(',') })
      })).json();
      if (messaggioDopo) mostraDopoRirendering(nuovaVariante, messaggioDopo);
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: carrello } }));
    } catch (e) {
      mostraErrore(riga, 'Errore di rete, riprova.');
    } finally {
      riga.removeAttribute('aria-busy');
      caricamento(false);
    }
  }

  /* ------------------------------------------------------------------ quantita' istantanea */
  /* Per ogni riga in sospeso (chiave di riga di Shopify, stabile al cambio quantita'):
       obiettivo = quantita' voluta dal cliente (dopo l'ultimo click);
       inviata   = quantita' dell'ultima richiesta partita (null se non ne e' partita nessuna);
       partita   = quando e' partita;  timer = rinvio di 300 ms dopo l'ultimo click;  scadenza = tempo massimo.
     L'attributo value dell'input dice cosa ha reso il server: finche' non coincide con "inviata" la richiesta
     e' in volo e la successiva (se l'obiettivo e' cambiato) parte al rirendering (cart-drawer:refreshed). */
  var pendenti = new Map(); /* chiave di riga -> { obiettivo, inviata, partita, timer, scadenza } */
  var ATTESA_MASSIMA = 8000;

  function quantitaResa(input) { return parseInt(input.getAttribute('value'), 10) || 0; }

  function inputDi(chiave) { return document.querySelector('.carrello-riga input[data-line-key="' + chiave + '"]'); }

  /* solo .value: un evento "input" farebbe cercare a Prestige dei <button> che qui sono link */
  function mostraObiettivo(input, obiettivo) {
    input.value = obiettivo;
    input.closest('.quantity-selector').classList.add('is-attesa');
  }

  function chiudiAttesa(chiave, input) {
    var p = pendenti.get(chiave);
    if (p) { clearTimeout(p.timer); clearTimeout(p.scadenza); }
    pendenti.delete(chiave);
    if (!input) return;
    input.value = quantitaResa(input);
    input.closest('.quantity-selector').classList.remove('is-attesa');
  }

  /* decide per una riga in sospeso: richiesta in volo -> si aspetta il rirendering; obiettivo gia' reso -> fine,
     numero nero; altrimenti parte la richiesta con l'obiettivo */
  function inviaQuantita(chiave) {
    var p = pendenti.get(chiave);
    if (!p) return;
    p.timer = null;
    var input = inputDi(chiave);
    if (!input) { chiudiAttesa(chiave, null); return; }
    var resa = quantitaResa(input);
    if (p.inviata !== null && p.inviata !== resa) { mostraObiettivo(input, p.obiettivo); return; }
    if (p.obiettivo === resa) { chiudiAttesa(chiave, input); return; }
    p.inviata = p.obiettivo;
    p.partita = performance.now();
    clearTimeout(p.scadenza);
    p.scadenza = setTimeout(function () { if (pendenti.get(chiave) === p) chiudiAttesa(chiave, inputDi(chiave)); }, ATTESA_MASSIMA);
    mostraObiettivo(input, p.obiettivo);
    /* lo stesso evento che Prestige ascolta quando il numero si scrive a mano: fa lui cart/change.js e rirendering */
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function passoQuantita(tasto) {
    var riquadro = tasto.closest('.quantity-selector');
    var input = riquadro && riquadro.querySelector('input[data-line-key]');
    if (!input) return;
    var chiave = input.getAttribute('data-line-key');
    var richiesta = parseInt(new URL(tasto.href, location.href).searchParams.get('quantity'), 10);
    var verso = richiesta < quantitaResa(input) ? -1 : 1;
    var p = pendenti.get(chiave) || { obiettivo: quantitaResa(input), inviata: null, partita: 0, timer: null, scadenza: null };
    if (p.inviata === 0) return; /* rimozione gia' chiesta: la riga sta per sparire */
    var nuova = p.obiettivo + verso;
    var massimo = parseInt(input.max, 10);
    if (nuova < 0 || (massimo && nuova > massimo)) return;
    p.obiettivo = nuova;
    pendenti.set(chiave, p);
    mostraObiettivo(input, nuova);
    clearTimeout(p.timer);
    if (nuova === 0) { inviaQuantita(chiave); return; }
    p.timer = setTimeout(function () { inviaQuantita(chiave); }, 300);
  }

  /* a ogni rirendering del drawer (risposta di questa riga, di un'altra, cambio taglia...) le righe in sospeso
     ritrovano il loro NUOVO input: riga sparita -> fine; click recente -> si riscrive l'obiettivo e decide il
     timer; altrimenti decide subito inviaQuantita (richiesta atterrata -> parte la successiva) */
  document.addEventListener('cart-drawer:refreshed', function () {
    pendenti.forEach(function (p, chiave) {
      var input = inputDi(chiave);
      if (!input) { chiudiAttesa(chiave, null); return; }
      if (p.timer) { mostraObiettivo(input, p.obiettivo); return; }
      inviaQuantita(chiave);
    });
  });

  /* Prestige emette theme:loading:end a richiesta finita e, se e' andata bene, subito dopo cart-drawer:refreshed.
     Se 300 ms dopo una riga aspetta ancora la risposta di una richiesta partita prima di questo evento, quella
     richiesta e' fallita: il numero torna quello reso. Se la rete cade prima (nessun evento) ci pensa scadenza. */
  document.addEventListener('theme:loading:end', function () {
    var fine = performance.now();
    setTimeout(function () {
      pendenti.forEach(function (p, chiave) {
        if (p.timer || p.inviata === null || p.partita >= fine) return;
        chiudiAttesa(chiave, inputDi(chiave));
      });
    }, 300);
  });

  /* ------------------------------------------------------------------ lightbox */
  var aperto = null;

  /* indice della foto visibile nella miniatura: stessa formula di indiceDi nel modulo galleria (IIFE separata,
     non esportata) */
  function indiceMiniatura(riga) {
    var pista = riga.querySelector('.carrello-riga__apri .scheda-galleria__pista');
    if (!pista) return 0;
    var w = pista.clientWidth || 1;
    return Math.max(0, Math.min(pista.children.length - 1, Math.round(pista.scrollLeft / w)));
  }

  function apriLightbox(riga) {
    var tpl = riga.querySelector('template.carrello-lightbox__foto');
    if (!tpl || aperto) return;
    if (!tpl.content.querySelector('.scheda-galleria__slide')) return;

    /* il markup del lightbox (titolo, X, pista, frecce e puntini) e' nel <template> di carrello-riga.liquid */
    var dlg = document.createElement('dialog');
    dlg.className = 'carrello-lightbox';
    dlg.setAttribute('aria-label', tpl.getAttribute('data-titolo') || '');
    dlg.appendChild(tpl.content.cloneNode(true));
    dlg.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });

    var contenitore = riga.closest('cart-drawer') || document.body;
    contenitore.appendChild(dlg);
    aperto = dlg;

    dlg.querySelector('.carrello-lightbox__chiudi').addEventListener('click', chiudiLightbox);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); chiudiLightbox(); });
    dlg.addEventListener('close', function () { if (aperto === dlg) { aperto = null; dlg.remove(); } });

    dlg.showModal();
    var idx = indiceMiniatura(riga);
    if (idx > 0) {
      var pista = dlg.querySelector('.scheda-galleria__pista');
      /* il puntino lo accende il modulo galleria allo scroll: ascolta ogni pista dentro un data-galleria-host */
      pista.scrollTo({ left: idx * pista.clientWidth, behavior: 'auto' });
    }
  }

  function chiudiLightbox() {
    if (!aperto) return;
    var dlg = aperto;
    aperto = null;
    try { dlg.close(); } catch (_) {}
    dlg.remove();
  }

  function scorriLightbox(dir) {
    if (!aperto) return;
    var freccia = aperto.querySelector(dir < 0 ? '.scheda-galleria__freccia--prev' : '.scheda-galleria__freccia--next');
    if (freccia) freccia.click();
  }

  /* ------------------------------------------------------------------ eventi */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var modifica = t.closest('.carrello-riga__modifica');
    if (modifica) {
      var box = document.getElementById(modifica.getAttribute('aria-controls'));
      if (box) { box.hidden = !box.hidden; modifica.setAttribute('aria-expanded', String(!box.hidden)); }
      return;
    }

    var opzione = t.closest('.carrello-riga__opzione');
    if (opzione) {
      if (!opzione.disabled && !opzione.classList.contains('is-selected')) cambiaTaglia(opzione);
      return;
    }

    var apri = t.closest('[data-carrello-lightbox]');
    if (apri) {
      /* le frecce della miniatura stanno fuori dal bottone, quindi qui arriva solo il click sulla foto */
      e.preventDefault();
      var riga = rigaDi(apri);
      if (riga) apriLightbox(riga);
    }
  });

  /* + e - della riga: in cattura, prima del delegate di Prestige (che sta sul <line-item-quantity>) */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var tasto = t.closest('.carrello-riga .quantity-selector a[href*="/cart/change"]');
    if (!tasto) return;
    e.preventDefault();
    e.stopPropagation();
    passoQuantita(tasto);
  }, true);

  window.addEventListener('keydown', function (e) {
    if (!aperto) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); chiudiLightbox(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); scorriLightbox(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); scorriLightbox(1); }
  }, true);
})();